// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sensorGallery__eU5hy {
  padding: 15px;
  display: flex;
  flex-direction: column;
  background: var(--inputs-disable-disable-surface);
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  min-width: 0;
  height: 198px;
}

.noImageGallery__n9yXS {
  height: 213px;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.photoIcon__UcQqp {
  width: 40px;
  height: 40px;
}

.noImageTitle__nvDcQ {
  color: var(--tables-secondary-row-sub-title-text);
  display: block;
  text-align: center;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
}

.noImageDescription__tjWPW {
  display: block;
  color: var(--tables-primary-row-text-additional);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0.11px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/SensorsList/components/EmptySensorGalleryBlock/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;AAzEF;;AA6EA;EACE,iDAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA1EF;;AA6EA;EACE,cAAA;EACA,gDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AA1EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.sensorGallery {\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  background: var(--inputs-disable-disable-surface);\n  position: relative;\n  overflow: hidden;\n  border-radius: 4px;\n  min-width: 0;\n  height: 198px;\n}\n\n.noImageGallery {\n  height: 213px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n}\n\n.photoIcon {\n  width: 40px;\n  height: 40px;\n}\n\n\n.noImageTitle {\n  color: var(--tables-secondary-row-sub-title-text);\n  display: block;\n  text-align: center;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n}\n\n.noImageDescription {\n  display: block;\n  color: var(--tables-primary-row-text-additional);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px;\n  letter-spacing: 0.11px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sensorGallery": `sensorGallery__eU5hy`,
	"noImageGallery": `noImageGallery__n9yXS`,
	"photoIcon": `photoIcon__UcQqp`,
	"noImageTitle": `noImageTitle__nvDcQ`,
	"noImageDescription": `noImageDescription__tjWPW`
};
module.exports = ___CSS_LOADER_EXPORT___;
